import { render, staticRenderFns } from "./ticketpromediomensual.vue?vue&type=template&id=97c52e70"
import script from "./ticketpromediomensual.vue?vue&type=script&lang=js"
export * from "./ticketpromediomensual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports